// Make sure GSAP and ScrollTrigger are loaded
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

function initParallax() {
  const parallaxElements = document.querySelectorAll('[data-parallax]');

  parallaxElements.forEach(el => {
    const speed = parseFloat(el.dataset.parallax);

    gsap.to(el, {
      y: () => -(window.innerHeight * speed / 10),
      ease: 'none',
      scrollTrigger: {
        trigger: el,
        start: 'top bottom', // when top of el hits bottom of viewport
        end: 'bottom+=100 top',   // when bottom of el hits top of viewport
        scrub: true,
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", initParallax);
